import React, { useContext, useEffect, useRef, useState } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  faAngleRight,
  faBars,
  faBriefcase,
  faCalendar,
  faClose,
  faHome,
  faListUl,
  faPlus,
  faSortDown,
  faWallet,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Blue_White_Gradient_Btn from "../common_components/common_btn/blue_white_gradient_btn/Blue_White_Gradient_Btn";
import {
  Container,
  Dropdown,
  Form,
  InputGroup,
  Nav,
  Navbar,
  Offcanvas,
} from "react-bootstrap";
import Orange_White_Border_Btn from "../common_components/common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import Cookies from "js-cookie";
import Instruments from "../trade_main/trade_components/instruments/Instruments";
import Economic_Calendar from "../trade_main/trade_components/economic_calendar/Economic_Calendar";
import Portfolio from "../trade_main/trade_components/main_chart_section/portfolio/Portfolio";
import Sidebar_List from "../sidebar/sidebar_list/Sidebar_List";
import Notification_Offcanvas from "../common_components/common_offcanvas/notification_offcanvas/Notification_Offcanvas";
import { Context } from "../../utils/context";
import { getNotification } from "../../utils/apis/notification/notification";

function Header() {
  const { userdata, signin, headerCompanyName } = useContext(Context);


  const location = useLocation();
  const navigate = useNavigate();



  const [show, setShow] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showPortfolioOff, setShowPortfolioOff] = useState(false);
  const [showInnerTab, setShowInnerTab] = useState(false);

  const [innerActiveTab, setInnerActiveTab] = useState("");

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      handleNavItemClick("/withdrawal");
    }, 100);
  };

  const handleShow = () => setShow(true);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showWalletDropdown, setShowWalletDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const dropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);

  const handleToggle = () => {
    setShowWalletDropdown((prev) => !prev);
  };

  const handleProfileToggle = () => {
    setShowProfileDropdown((prev) => !prev);
  };

  const isTrade = location.pathname === "/trade";

  const handleNavClick = () => {
    setShow(false);
  };

  const scrollRef = useRef();
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    let isDown = false;
    let startX;
    let scrollLeft;

    const onMouseDown = (e) => {
      isDown = true;
      container.classList.add("grabbing");
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    };

    const onMouseLeave = () => {
      isDown = false;
      container.classList.remove("grabbing");
    };

    const onMouseUp = () => {
      isDown = false;
      container.classList.remove("grabbing");
    };

    const onMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2; // Adjust scroll speed
      container.scrollLeft = scrollLeft - walk;
    };

    container.addEventListener("mousedown", onMouseDown);
    container.addEventListener("mouseleave", onMouseLeave);
    container.addEventListener("mouseup", onMouseUp);
    container.addEventListener("mousemove", onMouseMove);

    return () => {
      container.removeEventListener("mousedown", onMouseDown);
      container.removeEventListener("mouseleave", onMouseLeave);
      container.removeEventListener("mouseup", onMouseUp);
      container.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  const navbarToggleRef = useRef(null);

  const handleNavItemClick = (path) => {
    if (path) {
      navigate(`${path}`);
    }

    if (navbarToggleRef.current && window.innerWidth <= 992) {
      navbarToggleRef.current.click();
    }
  };

  const handleSignOut = () => {
    Cookies.remove("stoxwave_security");
    navigate("/login");
  };

  return (
    <>
      <section className="header_main">
        <div className="header_section">
          {/* dresktop view navbar -----------------------------------------------------------------------------------------------------------------------*/}

          <div className="desktop_view_navbar">
            <Navbar expand="lg" className="bg-body-tertiary">
              <Container>
                <Navbar.Brand>
                  <div className="left_side">
                    <div className="logo_div">
                      <Link to="/my-account">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/header/logo.png"
                          }
                          alt="logo"
                          className="logo_img"
                        />
                      </Link>
                    </div>
                  </div>
                </Navbar.Brand>

                <Navbar.Toggle
                  aria-controls="basic-navbar-nav"
                  ref={navbarToggleRef}
                />
                <Navbar.Collapse id="basic-navbar-nav">
                  {isTrade && (
                    <>
                      <Nav className="tradenav">
                        {/* <div className="currency_main_div">
                          <div className="curreny_type_divs" ref={scrollRef}>
                            {currencydata?.map((item) => {
                              return (
                                <div className="divs_holder">
                                  <div className="currency_div common_gray_box">
                                    <div className="img_holder">
                                      <img
                                        src={process.env.PUBLIC_URL + item?.img}
                                        className="small_img"
                                      />
                                    </div>
                                    <p className="currency_text">{item?.label}</p>
                                  </div>

                                  <div className="close_icon_holder">
                                    <FontAwesomeIcon
                                      icon={faClose}
                                      className="close_icon"
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          <div className="add_more_div common_gray_box">
                            <FontAwesomeIcon icon={faPlus} className="icon" />
                          </div>
                        </div> */}
                        {/* <p className="company_name_text">{headerCompanyName}</p> */}

                        <div className="trade_right_side">
                          <Nav.Link>
                            <div className="diposit_dropdown">
                              <Dropdown
                                show={showDropdown}
                                onToggle={() => setShowDropdown(!showDropdown)}
                              >
                                {signin ? (
                                  userdata?.accept_or_reject === 2 ? (
                                    <div className="diposit_btn signup_btn">
                                      <Blue_White_Gradient_Btn
                                        btn_name="Verify Profile"
                                        onClick={() => navigate("/settings")}
                                      />
                                    </div>
                                  ) : (
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      <p className="top_text">
                                        {userdata?.first_name}{" "}
                                        <span className="no_text">
                                          # {userdata?.customer_no}
                                        </span>
                                      </p>

                                      <p className="amount_text">
                                        ${userdata?.UserWallet?.amount}
                                        <FontAwesomeIcon
                                          className="icon_class"
                                          icon={faSortDown}
                                        />
                                      </p>
                                    </Dropdown.Toggle>
                                  )
                                ) : (
                                  <div className="diposit_btn signup_btn">
                                    <Blue_White_Gradient_Btn
                                      btn_name="Signup/Login"
                                      onClick={() => navigate("/login")}
                                    />
                                  </div>
                                )}

                                <Dropdown.Menu
                                  className={!showDropdown ? "hide" : ""}
                                >
                                  <div className="first_menu_div">
                                    <div className="text_div">
                                      <p className="lebel_text">Balance</p>
                                      <p className="value_text">
                                        <span className="green">
                                          {userdata?.UserWallet?.amount}
                                        </span>{" "}
                                        $
                                      </p>
                                    </div>

                                    <div className="text_div">
                                      <p className="lebel_text">Margin</p>
                                      <p className="value_text">
                                        <span className="green">
                                          {userdata?.UserWallet?.amount}
                                        </span>{" "}
                                        $
                                      </p>
                                    </div>

                                    <div className="btns_holder">
                                      <div className="withdraw_btn">
                                        <Blue_White_Gradient_Btn
                                          btn_name="Withdraw"
                                          onClick={() => {
                                            {
                                              setTimeout(() => {
                                                handleNavItemClick(
                                                  "/withdrawal"
                                                );
                                              }, 100);
                                              setShowDropdown(!showDropdown);
                                            }
                                          }}
                                        />
                                      </div>
                                      {userdata?.accept_or_reject === 1 ? (
                                        <div className="diposit_btn">
                                          <Orange_White_Border_Btn
                                            btn_name="Deposit"
                                            onClick={() => {
                                              {
                                                setTimeout(() => {
                                                  handleNavItemClick(
                                                    "/deposit"
                                                  );
                                                }, 100);
                                                setShowDropdown(!showDropdown);
                                              }
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Nav.Link>
                          {signin && userdata?.accept_or_reject == 1 && (
                            <Nav.Link>
                              <div className="diposit_btn">
                                <Blue_White_Gradient_Btn
                                  btn_name="Deposit"
                                  onClick={() => {
                                    setTimeout(() => {
                                      handleNavItemClick("/deposit");
                                    }, 100);
                                  }}
                                />
                              </div>
                            </Nav.Link>
                          )}
                        </div>
                      </Nav>
                    </>
                  )}

                  {!isTrade && (
                    <Nav className="ms-auto">
                      <>
                        <Nav.Link>
                          <div className="wallet_dropdown">
                            <Dropdown
                              align="end"
                              show={showWalletDropdown}
                              onToggle={() =>
                                setShowWalletDropdown(!showWalletDropdown)
                              }
                              ref={dropdownRef}
                            >
                              <div
                                className="wallet_div"
                                onClick={handleToggle}
                              >
                                <p className="wallet_text">
                                  {" "}
                                  {userdata?.UserWallet?.amount} $
                                </p>
                                <div className="icon_holder">
                                  <FontAwesomeIcon
                                    icon={faWallet}
                                    className="icon"
                                  />
                                </div>
                              </div>

                              <Dropdown.Menu
                                className={
                                  !showWalletDropdown ? "hidewallet" : ""
                                }
                              >
                                <div className="wallet_modal_div">
                                  <div className="header">
                                    <p className="heading">Wallet</p>
                                    <div
                                      className="iocn_holder"
                                      onClick={handleToggle}
                                    >
                                      <FontAwesomeIcon
                                        icon={faXmark}
                                        className="close"
                                      />
                                    </div>
                                  </div>

                                  <div className="info_div">
                                    <div className="text_div">
                                      <p className="label">Trading Account</p>
                                      <p className="amount">
                                        ${" "}
                                        <span className="inner_text">
                                          {userdata?.UserWallet?.amount}
                                        </span>{" "}
                                      </p>
                                    </div>

                                    <p className="id_text">
                                      #{userdata?.customer_no}
                                    </p>
                                  </div>

                                  <div className="withdraw_div">
                                    <Orange_White_Border_Btn
                                      btn_name="Withdraw"
                                      onClick={() => {
                                        handleToggle();
                                        setTimeout(() => {
                                          handleNavItemClick("/withdrawal");
                                        }, 100);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </Nav.Link>

                        <Nav.Link>
                          <div className="bell_img_holder" onClick={handleShow}>
                            <Link>
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/header/bell2.png"
                                }
                                alt="logout"
                                className="user_img"
                              />
                            </Link>
                          </div>
                        </Nav.Link>

                        <Nav.Link>
                          <div className="profile_div">
                            <Dropdown
                              align="end"
                              show={showProfileDropdown}
                              onToggle={() =>
                                setShowProfileDropdown(!showProfileDropdown)
                              }
                              ref={profileDropdownRef}
                            >
                              <Dropdown.Toggle
                                as="div"
                                className="custom_toggle"
                                onClick={handleProfileToggle}
                              >
                                <div className="img_holder">
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/header/profile.png"
                                    }
                                    alt="logout"
                                    className="user_img"
                                  />
                                </div>
                              </Dropdown.Toggle>

                              <Dropdown.Menu
                                className={
                                  !showProfileDropdown ? "hideprofile" : ""
                                }
                              >
                                <div className="profile_modal_div">
                                  <div className="top_heading">
                                    <div className="img_holder">
                                      <img
                                        src="/assets/images/profile/profile.png"
                                        className="profile_img"
                                      />
                                    </div>
                                    <p className="name">
                                      {userdata?.first_name}{" "}
                                      {userdata?.last_name}
                                    </p>
                                  </div>
                                  <p className="email">
                                    Refer Code - {userdata?.refer_code}
                                  </p>
                                  <p className="email">
                                    Customer No - #{userdata?.customer_no}
                                  </p>{" "}
                                  <p className="email">
                                    Contact No - {userdata?.contact_no}
                                  </p>
                                  <p className="email">{userdata?.email}</p>
                                  {/* <InputGroup className="mb-3">
                                    <Form.Control
                                      placeholder="Recipient's username"
                                      aria-label="Recipient's username"
                                      aria-describedby="basic-addon2"
                                    />
                                    <InputGroup.Text id="basic-addon2">
                                      <div
                                        className="icon_holder"
                                        onClick={() => {
                                          {
                                            navigate("/settings");
                                            handleProfileToggle();
                                          }
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faAngleRight}
                                          className="icon"
                                        />
                                      </div>
                                    </InputGroup.Text>
                                  </InputGroup> */}
                                  <div className="sign_out_btn">
                                    <Orange_White_Border_Btn
                                      btn_name="Sign Out"
                                      onClick={handleSignOut}
                                    />
                                  </div>
                                </div>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </Nav.Link>
                      </>
                    </Nav>
                  )}
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </div>

          {/* mobile view navbar -----------------------------------------------------------------------------------------------------------------------*/}

          <div className="mobile_view_navbar">
            {signin ? (
              isTrade ? (
                <div
                  className="menu_icon_holder"
                  onClick={() => setShowMobileMenu(true)}
                >
                  <FontAwesomeIcon icon={faHome} className="icon" />
                </div>
              ) : (
                <div
                  className="menu_icon_holder"
                  onClick={() => setShowMobileMenu(true)}
                >
                  <FontAwesomeIcon icon={faBars} className="icon" />
                </div>
              )
            ) : (
              <div
                className="menu_icon_holder"
                onClick={() => navigate("/login")}
              >
                <FontAwesomeIcon icon={faHome} className="icon" />
              </div>
            )}

            {/* <p className="company_name_text">{headerCompanyName}</p> */}

            <div className="right_side">
              <Navbar>
                <Navbar.Collapse id="basic-navbar-nav">
                  {isTrade && (
                    <>
                      <Nav className="tradenav">
                        <div className="trade_right_side">
                          <Nav.Link>
                            <div className="diposit_dropdown">
                              <Dropdown
                                show={showDropdown}
                                onToggle={() => setShowDropdown(!showDropdown)}
                              >
                                {signin ? (
                                  userdata?.accept_or_reject === 2 ? (
                                    <div className="diposit_btn signup_btn">
                                      <Blue_White_Gradient_Btn
                                        btn_name="Verify Profile"
                                        onClick={() => navigate("/settings")}
                                      />
                                    </div>
                                  ) : (
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      <p className="top_text">
                                        <p className="name">
                                          {userdata?.first_name}{" "}
                                          {userdata?.last_name}
                                        </p>
                                        <span className="no_text">
                                          # {userdata?.customer_no}
                                        </span>
                                      </p>
                                      <p className="amount_text">
                                        {userdata?.UserWallet?.amount} ${" "}
                                        <FontAwesomeIcon
                                          className="icon_class"
                                          icon={faSortDown}
                                        />
                                      </p>
                                    </Dropdown.Toggle>
                                  )
                                ) : (
                                  <div className="diposit_btn signup_btn">
                                    <Blue_White_Gradient_Btn
                                      btn_name="Signup/Login"
                                      onClick={() => navigate("/login")}
                                    />
                                  </div>
                                )}

                                <Dropdown.Menu
                                  className={!showDropdown ? "hide" : ""}
                                >
                                  <div className="first_menu_div">
                                    <div className="text_div">
                                      <p className="lebel_text">Balance</p>
                                      <p className="value_text">
                                        <span className="green">
                                          {userdata?.UserWallet?.amount}
                                        </span>{" "}
                                        $
                                      </p>
                                    </div>

                                    <div className="text_div">
                                      <p className="lebel_text">Margin</p>
                                      <p className="value_text">
                                        <span className="green">
                                          {userdata?.UserWallet?.amount}
                                        </span>{" "}
                                        $
                                      </p>
                                    </div>

                                    <div className="btns_holder">
                                      <div className="withdraw_btn">
                                        <Blue_White_Gradient_Btn
                                          btn_name="Withdraw"
                                          onClick={() => {
                                            {
                                              setTimeout(() => {
                                                handleNavItemClick(
                                                  "/withdrawal"
                                                );
                                              }, 100);
                                              setShowDropdown(!showDropdown);
                                            }
                                          }}
                                        />
                                      </div>
                                      {userdata?.accept_or_reject == 1 ? (
                                        <div className="diposit_btn">
                                          <Orange_White_Border_Btn
                                            btn_name="Deposit"
                                            onClick={() => {
                                              {
                                                setTimeout(() => {
                                                  handleNavItemClick(
                                                    "/deposit"
                                                  );
                                                }, 100);
                                                setShowDropdown(!showDropdown);
                                              }
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Nav.Link>

                          {signin && userdata?.accept_or_reject == 1 && (
                            <Nav.Link>
                              <div className="diposit_btn">
                                <Blue_White_Gradient_Btn
                                  btn_name="Deposit"
                                  onClick={() => {
                                    setTimeout(() => {
                                      handleNavItemClick("/deposit");
                                    }, 100);
                                  }}
                                />
                              </div>
                            </Nav.Link>
                          )}
                        </div>
                      </Nav>
                    </>
                  )}

                  {!isTrade && (
                    <Nav className="ms-auto">
                      <>
                        {signin && (
                          <Nav.Link>
                            <div className="wallet_dropdown">
                              <Dropdown
                                align="end"
                                show={showWalletDropdown}
                                onToggle={() =>
                                  setShowWalletDropdown(!showWalletDropdown)
                                }
                                ref={dropdownRef}
                              >
                                <div
                                  className="wallet_div"
                                  onClick={handleToggle}
                                >
                                  <p className="wallet_text">
                                    {userdata?.UserWallet?.amount} $
                                  </p>
                                  <div className="icon_holder">
                                    <FontAwesomeIcon
                                      icon={faWallet}
                                      className="icon"
                                    />
                                  </div>
                                </div>

                                <Dropdown.Menu
                                  className={
                                    !showWalletDropdown ? "hidewallet" : ""
                                  }
                                >
                                  <div className="wallet_modal_div">
                                    <div className="header">
                                      <p className="heading">Wallet</p>
                                      <div
                                        className="iocn_holder"
                                        onClick={handleToggle}
                                      >
                                        <FontAwesomeIcon
                                          icon={faXmark}
                                          className="close"
                                        />
                                      </div>
                                    </div>

                                    <div className="info_div">
                                      <div className="text_div">
                                        <p className="label">Trading Account</p>
                                        <p className="amount">
                                          <span className="inner_text">
                                            {" "}
                                            {userdata?.UserWallet?.amount}
                                          </span>{" "}
                                          $
                                        </p>
                                      </div>
                                      <p className="id_text">
                                        #{userdata?.customer_no}
                                      </p>
                                    </div>

                                    <div className="withdraw_div">
                                      <Orange_White_Border_Btn
                                        btn_name="Withdraw"
                                        onClick={() => {
                                          handleToggle();
                                          setTimeout(() => {
                                            handleNavItemClick("/withdrawal");
                                          }, 100);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Nav.Link>
                        )}

                        {signin ? (
                          <Nav.Link>
                            <div className="profile_div">
                              <Dropdown
                                align="end"
                                show={showProfileDropdown}
                                onToggle={() =>
                                  setShowProfileDropdown(!showProfileDropdown)
                                }
                                ref={profileDropdownRef}
                              >
                                <Dropdown.Toggle
                                  as="div"
                                  className="custom_toggle"
                                  onClick={handleProfileToggle}
                                >
                                  <div className="img_holder">
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/header/profile.png"
                                      }
                                      alt="logout"
                                      className="user_img"
                                    />
                                  </div>
                                </Dropdown.Toggle>

                                <Dropdown.Menu
                                  className={
                                    !showProfileDropdown ? "hideprofile" : ""
                                  }
                                >
                                  <div className="profile_modal_div">
                                    <div className="top_heading">
                                      <div className="img_holder">
                                        <img
                                          src="/assets/images/profile/profile.png"
                                          className="profile_img"
                                        />
                                      </div>
                                      <p className="name">
                                        {" "}
                                        {userdata?.first_name}{" "}
                                        {userdata?.last_name}
                                      </p>
                                    </div>

                                    <p className="email">{userdata?.email}</p>

                                    <Orange_White_Border_Btn
                                      btn_name="Sign Out"
                                      onClick={handleSignOut}
                                    />
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Nav.Link>
                        ) : (
                          <div
                            className="img_holder"
                            onClick={() => {
                              navigate("/login");
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/header/profile.png"
                              }
                              alt="logout"
                              className="user_img"
                            />
                          </div>
                        )}
                      </>
                    </Nav>
                  )}
                </Navbar.Collapse>
              </Navbar>
            </div>
          </div>
        </div>

        <Offcanvas
          className="menu_offcanvas"
          show={showMobileMenu}
          onHide={() => setShowMobileMenu(false)}
          placement="start"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <div className="left_side">
                <div className="logo_div">
                  <Link to="/my-account">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/header/logo.png"
                      }
                      alt="logo"
                      className="logo_img"
                    />
                  </Link>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <>
              {isTrade && (
                <div className="main_div">
                  <Sidebar_List
                    handleClose={() => {
                      setShowMobileMenu(false);
                    }}
                    notificationAction={() => setShow(true)}
                  />

                  {/* <div
                    className="link_div"
                    onClick={() => {
                      navigate("/my-account");
                      setShowMobileMenu(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faHome} className="tool_icon" />
                    <p className="link_text">Home</p>
                  </div> */}
                  {/* 
                  <div
                    className="link_div"
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      setShowInnerTab(true);
                      setInnerActiveTab(1);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setShowInnerTab(true);
                        setInnerActiveTab(1);
                      }
                    }}
                  >
                    <FontAwesomeIcon icon={faListUl} className="tool_icon" />
                    <p className="link_text">Instruments</p>
                  </div> */}

                  {/* <div
                    className="link_div"
                    onClick={() => {
                      setShowInnerTab(true);
                      setInnerActiveTab(2);
                    }}
                  >
                    <FontAwesomeIcon icon={faCalendar} className="tool_icon" />
                    <p className="link_text">Economic Calendar</p>
                  </div> */}

                  {/* <div
                    className="link_div"
                    onClick={() => {
                      setShowPortfolioOff(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faBriefcase} className="tool_icon" />
                    <p className="link_text">Portfoilo</p>
                  </div> */}
                </div>
              )}

              {!isTrade && (
                <Sidebar_List
                  handleClose={() => {
                    setShowMobileMenu(false);
                  }}
                  notificationAction={() => setShow(true)}
                />
              )}
            </>
          </Offcanvas.Body>
        </Offcanvas>

        <Offcanvas
          className="inner_menu_offcanvas"
          show={showInnerTab}
          onHide={() => setShowInnerTab(false)}
          placement="start"
        >
          <Offcanvas.Body>
            {innerActiveTab === 1 && (
              <Instruments
                onClose={() => {
                  setShowInnerTab(false);
                }}
              />
            )}

            {innerActiveTab === 2 && (
              <Economic_Calendar
                onClose={() => {
                  setShowInnerTab(false);
                }}
              />
            )}
          </Offcanvas.Body>
        </Offcanvas>

        <Offcanvas
          className="portfolio_offcanvas"
          show={showPortfolioOff}
          onHide={() => {
            setShowPortfolioOff(false);
          }}
          placement="start"
        >
          <Offcanvas.Header className="Instruments">
            <div class="heading_part">
              <p class="heading_name">Portfolio</p>
              <div
                class="img_holder"
                onClick={() => {
                  setShowPortfolioOff(false);
                }}
              >
                <img src="/assets/images/trade/close.png" class="close_img" />
              </div>
            </div>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="main_div">
              <Portfolio />
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        <Notification_Offcanvas
          show={show}
          onHide={handleClose}
          // notificationData={notificationData}
        />
      </section>
    </>
  );
}

export default Header;
